module.exports = __webpack_public_path__ + "img/arrow_up.6cf33e6c.png";